import { toggleFlatViewOrderBanner } from '../../../shared/actions/flatViewOrder';
import { setFlatViewOrder } from '../../../shared/actions/newbuilding';
import { transformUserBookingStatus } from '../../../shared/mappers/transformUserBookingStatus';
import {
  fetchAddFlatTourBooking,
  TAddFlatTourBookingRequest,
  TAddFlatTourBookingResponse,
} from '../../../shared/repositories/newbuilding-flat-tour-booking/v1/add-flat-tour-booking';
import { TThunkAction } from '../../../shared/types/redux/thunk';

export function addFlatTourBooking(parameters: TAddFlatTourBookingRequest): TThunkAction {
  return async (dispatch, getState, { httpApi, logger }) => {
    try {
      const response: TAddFlatTourBookingResponse = await fetchAddFlatTourBooking({
        httpApi,
        parameters: {
          ...parameters,
        },
        config: {
          requestConfig: {
            headers: [['Content-type', 'application/json']],
          },
        },
      });

      if (response.statusCode !== 200) {
        throw response.response.message;
      }

      const userBookingStatus = transformUserBookingStatus(response.response.userBookingStatus);

      dispatch(setFlatViewOrder(userBookingStatus));
      dispatch(toggleFlatViewOrderBanner(true));
    } catch (error) {
      logger.error(error, {
        domain: 'addFlatTourBookingRequest',
      });

      throw error;
    }
  };
}
